import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AssetsSourcePipe } from '../../pipes/assets.pipe';

@Component({
    selector: 'splash-screen',
    imports: [AssetsSourcePipe],
    templateUrl: './splash-screen.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './splash-screen.component.scss'
})
export class SplashScreenComponent {}
